import axios, { AxiosError } from "axios";

export interface IApiError {
  error: string;
  code: number | string;
}

export const captureAxiosApiErrors = (error: unknown): IApiError => {
  let message = "Something went wrong!";
  let code: number | string = "UNKNOWN";

  if (axios.isAxiosError(error)) {
    const err = error as AxiosError<any>;

    if (err?.response) {
      if (err?.response?.data) {
        message =
          "message" in err?.response?.data?.message
            ? typeof err?.response?.data?.message
            : "Unknown error occured.";
      } else {
        message = "Unknown error occured.";
      }
      code = err?.response?.status;
    } else if (err?.request) {
      message = "No response from server. Please try again.";
      code = "NO_RESPONSE";
    } else {
      message = err?.message;
      code = "CLIENT_ERROR";
    }
  }

  return { error: message, code };
};
